import { DocumentoGescorDTO } from "./gescor/documeto-gescorDTO";

export class CaricaNuovaVersioneDocumentoRequestDTO {
  idDocumento: string;

  riferimentiRepository: DocumentoGescorDTO;
}
